import React from 'react';
import Dialog from 'react-bootstrap-dialog';
import { Row, Col, Button } from 'react-bootstrap';
import * as Convert from '../../../util/unitConversion';

class CallOffToExistingCallOff extends React.Component {
    constructor(props) {
        super(props);

        this.updateState = this.updateState.bind(this);
        this.calcWeightOrQuantity = this.calcWeightOrQuantity.bind(this);

        this.state = {
            selectCopy: null,
            orderBy: 'Q',
            plannedQuantity: 0,
            plannedWeight: 0
        };

        this.greaseProofUser = this.props.legalEntity === 'NP';
    }

    updateState(state, value) {
        this.setState({
            [state]: value
        })
    }

    // Beh�vs detta?
    calcWeightOrQuantity() {
        const order = this.props.order;
        if (!order) return false

        //
        // J_W
        //
        const { AVAILABLE_WEIGHT_UC, AVAILABLE_QUANTITY } = order
        let PLANNED_WEIGHT_UC = this.state.plannedWeight
        let PLANNED_QUANTITY = this.state.plannedQuantity
        let newPlannedWeight = PLANNED_WEIGHT_UC
        let newPlannedQuantity = PLANNED_QUANTITY

        if (this.state.orderBy == 'W')
            if (PLANNED_WEIGHT_UC <= order.AVAILABLE_WEIGHT_UC)
                newPlannedQuantity = ((PLANNED_WEIGHT_UC / AVAILABLE_WEIGHT_UC) * AVAILABLE_QUANTITY).toFixed(0)

        if (this.state.orderBy == 'Q')
            if (PLANNED_QUANTITY <= order.AVAILABLE_QUANTITY) 
                newPlannedWeight = ((AVAILABLE_WEIGHT_UC / AVAILABLE_QUANTITY) * PLANNED_QUANTITY).toFixed(1)

        //PEEK
        console.log("newPlannedWeight : " + newPlannedWeight);
        console.log("newPlannedQuantity : " + newPlannedQuantity);

        order.PLANNED_WEIGHT_UC = newPlannedWeight
        order.PLANNED_QUANTITY = newPlannedQuantity

        this.setState({
            plannedQuantity: newPlannedQuantity,
            plannedWeight: newPlannedWeight
        })
    }

    render() {
        const mystyle = {
            padding: "10px",
            width: "100%",
            borderRadius: "5px"
        }
        const greaseProofUser = this.greaseProofUser;
        const _order = this.props.order;
        const MAX_QUANTITY = _order.AVAILABLE_QUANTITY || 0;
        const MAX_WEIGHT = _order.AVAILABLE_WEIGHT_UC || 0;

        if (_order == null) return false;

        return (
            <div>
                <Row>
                    <Col xs={4}>
                        <label htmlFor="quantityBy">By</label>
                        <select id="quantityBy" disabled={greaseProofUser == false} style={mystyle} onChange={(item) => {
                            this.setState({
                                orderBy: item.target.value
                            });

                            // Reset the previus option
                            if (item.target.value === 'W') 
                                this.props.order.PLANNED_QUANTITY = 0;                      
                            else 
                                this.props.order.PLANNED_WEIGHT_UC = 0;
                        }}>
                            <option value="Q">Quantity</option>
                            <option value="W">Weight</option>
                        </select>
                    </Col>
                    <Col xs={4}>
                        <label htmlFor="quantityQuantity">Available quantity: {MAX_QUANTITY && <span>{MAX_QUANTITY}</span>}</label>
                        <input disabled={this.state.orderBy === 'W'} style={mystyle} type="number" min="0" max={MAX_QUANTITY} value={this.state.plannedQuantity} onChange={(item) => {
                            if (MAX_QUANTITY && item.target.value > MAX_QUANTITY) return false;
                            this.state.plannedQuantity = parseInt(item.target.value)
                            this.calcWeightOrQuantity()
                        }} />
                    </Col>
                    <Col xs={4}>
                        <label htmlFor="quantityWeight">Available weight {MAX_WEIGHT && <span>{MAX_WEIGHT}</span>}<Convert.TextTo value_metric={" (kg)"} value_imperial={" (lb)"}/></label>
                        <input disabled={this.state.orderBy === 'Q'} style={mystyle} type="number" min="0" max={MAX_WEIGHT} value={this.state.plannedWeight} onChange={(item) => {
                            if (MAX_WEIGHT && item.target.value > MAX_WEIGHT) return false;
                            this.state.plannedWeight = parseInt(item.target.value)
                            this.calcWeightOrQuantity()
                        }} />
                    </Col>
                </Row>
            </div>
        );      
    }
}



export default CallOffToExistingCallOff;
